import React from "react";

const DocumentModal = ({ documentUrl, onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-6xl">
        <h2 className="text-lg font-semibold mb-4">📄 Aperçu du document</h2>
        <div className="border rounded-lg overflow-hidden">
          <iframe src={documentUrl} className="w-full h-[80vh]"></iframe>
        </div>
        <button
          onClick={onClose}
          className="mt-4 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-700"
        >
          Fermer
        </button>
      </div>
    </div>
  );
};

export default DocumentModal;